import { listen, isChangeAccountMessage, isData } from "@sinch/bus";
import { useEffect } from "react";
import { authStrategy } from "./../auth/index";

// Currently is made for Message media partner functionality
export const useChangeAccountHandler = () => {
  useEffect(() => {
    const unsub = listen((message) => {
      if (isData(message)) {
        authStrategy.patchRefreshToken({
          accountId: message.payload.accountId,
        });
      }
    }, isChangeAccountMessage);

    return unsub;
  }, []);
};
